/* eslint complexity: ["error", 7] */
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import FormInput from '../../../../form-input/form-input';
import classNames from 'classnames';
import './PhoneField.less';

const noop = () => {};

class PhoneFieldWithoutMask extends Component {
    static propTypes = {
        onChange: PropTypes.func,
        onFocus: PropTypes.func,
        onBlur: PropTypes.func,
        phoneCode: PropTypes.string,
        phoneNumber: PropTypes.string,
        errorMsg: PropTypes.string,
        helpText: PropTypes.string,
        'aria-required': PropTypes.string,
    };

    static defaultProps = {
        l10n: {},
        onChange: noop,
        onFocus: noop,
        onBlur: noop,
        phoneCode: '1',
        phoneNumber: '',
    };

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const {phoneNumber} = this.props;

        if (phoneNumber) {
            this.telField.input.value = phoneNumber;
            this.props.onChange({}, this.getPhoneObject());
        }
    }

    componentDidUpdate(prevProps) {
        const {phoneCode, phoneNumber} = this.props;
        const currentValue =
            this.telField && this.telField.input.value
                ? this.telField.input.value
                : '';

        // Update input value when new phoneNumber prop is passed in and it
        // does not match current input value
        if (
            prevProps.phoneNumber !== phoneNumber &&
            phoneNumber !== currentValue
        ) {
            this.telField.input.value = phoneNumber;
            this.props.onChange({}, this.getPhoneObject());
        }

        if (prevProps.phoneCode !== phoneCode) {
            // Notify consumer about new phoneCode
            this.props.onChange({}, this.getPhoneObject());
        }
    }

    /** Can be called to externally focus the proper input component. */
    focus() {
        this.telField.focus();
    }

    /**
     * Generates an object containing the current state of the phone field.
     * @returns {{raw: string, formatted: string, phoneCode: string, isValid: boolean}}
     *  An object describing current state: raw is the unformatted phone number,
     *  formatted is same as the raw number since we aren't use a mask, phoneCode is the phone country code
     *  (e.g. '+1'), and isValid is always true since we aren't using a mask for validation.
     */
    getPhoneObject() {
        return {
            raw: this.telField && this.telField.input.value,
            formatted: this.telField && this.telField.input.value,
            phoneCode: this.props.phoneCode,
            isValid: true,
        };
    }

    // eslint-disable-next-line complexity
    handleChange = (e) => {
        this.props.onChange(e, this.getPhoneObject());
    };

    handleFocus = (e) => {
        this.props.onFocus(e, this.getPhoneObject());
    };

    handleBlur = (e) => {
        this.props.onBlur(e, this.getPhoneObject());
    };

    isNumberKey = (e) => {
        return (
            (e.which >= 48 && e.which <= 57) ||
            (e.which >= 96 && e.which <= 105)
        );
    };

    isAllowedNonNumericKey = (e) => {
        const isArrow = e.which >= 37 && e.which <= 40;
        const isTabOrDelete =
            e.which === 8 || e.which === 9 || e.which === 127 || e.which === 46;

        return isArrow || isTabOrDelete;
    };
    /* eslint-disable-next-line complexity */
    isAllowedCombination = (e) => {
        const isCtrl = !!(e.ctrlKey || e.metaKey);
        const isSelectAll = isCtrl && e.which === 65;
        const isCopy = isCtrl && e.which === 67;
        const isPaste = isCtrl && e.which === 86;
        const isCut = isCtrl && e.which === 88;
        const isUndo = isCtrl && e.which === 90;
        const isRedo = isCtrl && e.which === 89;

        return isSelectAll || isCopy || isPaste || isCut || isUndo || isRedo;
    };

    // ignore any key other than 0-9, (arrows), backspace, tab, delete, ctrl + a, cmd + a
    handleNonNumericalInput = (e = {}) => {
        if (
            !this.isNumberKey(e) &&
            !this.isAllowedNonNumericKey(e) &&
            !this.isAllowedCombination(e)
        ) {
            e.preventDefault();
        }
    };

    setTelFieldRef = (ref) => {
        this.telField = ref;
    };

    render() {
        const {
            id,
            l10n,
            phoneCode,
            showCountrySelect,
            phoneNumber,
            errorMsg,
            helpText,
            'aria-required': ariaRequired,
        } = this.props;

        const inputClassName = classNames({
            [`react-input-tel__country-code-${phoneCode.length}`]: true,
            'react-input-tel__phone-field': true,
            'show-dropdown': showCountrySelect,
            'not-empty':
                phoneNumber || (this.telField && this.telField.input.value),
        });

        return (
            <div
                role="presentation"
                className="input-group-wrapper"
                onKeyDown={this.handleNonNumericalInput}
            >
                <FormInput
                    ref={this.setTelFieldRef}
                    id={id}
                    data-wdio="input-tel__phone-field__input"
                    className={inputClassName}
                    leftContent={!showCountrySelect ? `+${phoneCode}` : null}
                    label={l10n['reactInputTel.input.label']}
                    errorMsg={errorMsg}
                    onChange={this.handleChange}
                    onFocus={this.handleFocus}
                    onBlur={this.handleBlur}
                    type="tel"
                    autoComplete="tel"
                    helpText={helpText}
                    aria-required={ariaRequired}
                />
            </div>
        );
    }
}

export default PhoneFieldWithoutMask;
